import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';
import Contact from './Contact';


class SupportRequest extends Component {


    render() {
        return (
            <Contact supportRequest={true} />
        );
    }
}

export default withRouter(SupportRequest);


// WEBPACK FOOTER //
// ./src/components/SupportRequest.js